// Hook pobiera status setup wizardu (czy zakonczony + lista ukonczonych krokow).
// GET /api/ui/core/panel/setup/status

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISetupStatusResponse {
  is_completed: boolean;
  completed_steps: number[];
}

const getSetupStatus = (): Promise<ISetupStatusResponse> =>
  axios.get('/core/panel/setup/status');

export const useGetSetupStatus = (options?: UseQueryOptions<ISetupStatusResponse, IError>) =>
  useQuery<ISetupStatusResponse, IError>(['setup-status'], () => getSetupStatus(), options);
